import { MediaRef } from "../../modules/player/MediaResource.js";
import { MediaContext } from "../../modules/player/Player.js";

export function formatTime(seconds: number) : string {

    const date = new Date(seconds * 1000);
    const hours = date.getUTCHours();
    const minutes = date.getUTCMinutes().toString().padStart(2, '0');
    const sec = date.getSeconds().toString().padStart(2, '0');

    const basetime = minutes.toString() + ':' + sec;

    return hours > 0 ? hours.toString() + ':' + basetime : basetime;
}

/**
 * Seeks the media context to `startingTimecode` once metadata is loaded.
 *
 * Safe to call during a preroll ad chain: the seek is queued inside the
 * ads-enriched context and flushed right before the content resumes, so
 * the starting timecode is honored also when ads play before the video.
 *
 * No-op when `startingTimecode` is falsy, not strictly positive, or greater
 * than or equal to the media duration.
 */
export function applyStartingTimecode<REF extends MediaRef<any, any>>(
    ctx: MediaContext<REF>,
    startingTimecode: number | undefined
): void {
    if (startingTimecode == null) return;
    if (!Number.isFinite(startingTimecode) || startingTimecode <= 0) {
        console.warn(`[applyStartingTimecode] ignored: value must be a positive finite number, got ${startingTimecode}`);
        return;
    }
    ctx.metadataPromise.then(() => {
        if (startingTimecode >= ctx.duration) {
            console.warn(`[applyStartingTimecode] ignored: value ${startingTimecode}s exceeds media duration (${ctx.duration}s)`);
            return;
        }
        console.info(`[applyStartingTimecode] seeking to ${startingTimecode}s (duration ${ctx.duration}s)`);
        ctx.seek(startingTimecode);
    });
}